import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../styles/PuppyApplication.css";

export default function PuppyApplicationFailedPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const message =
    location.state?.message ||
    "We were unable to submit your application. Please try again or contact us.";

  return (
    <div className="puppy-app-page">
      <div className="puppy-app-header fade-up">
        <div>
          <p className="puppy-app-kicker">Puppy Purchase Application</p>
          <h1 className="puppy-app-title">Submission failed</h1>
        </div>
        <p className="puppy-app-intro">
          We could not submit your application. Please contact us so we can help.
        </p>
      </div>

      <div className="puppy-app-form fade-up">
        <div className="failure-panel">
          <h2>We need your help</h2>
          <p>{message}</p>
        </div>

        <div className="review-actions">
          <button
            type="button"
            className="secondary-btn"
            onClick={() => navigate("/puppy-application/review")}
          >
            Back to review
          </button>
          <button
            type="button"
            className="primary-btn"
            onClick={() => navigate("/contact")}
          >
            Contact us
          </button>
        </div>
      </div>
    </div>
  );
}
